export default __webpack_public_path__ + "static/media/LilNounsReadingNouns.d2378f21.png";